/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
(function (Drupal, $) {
	"use strict";

	var TIMEOUT_MS = 10;
	var INCREMENT = 1;

	var COUNTERS;
	var COUNTER_TIMEOUTS;

	function incrementCounter(i, j, item) {
		var counter = COUNTERS[i][j];
		if (counter.curr === counter.end) {
			return;
		}

		var inc = INCREMENT;
		var timeoutms = TIMEOUT_MS;

		var onePercent = counter.end / 100;
		if (onePercent < 1) {
			timeoutms = timeoutms * Math.ceil(1 / (10 * onePercent));
		} else {
			inc = Math.min(Math.floor(onePercent), counter.end - counter.curr);
		}

		if (counter.end - counter.curr < 20) {
			inc = 1;
		}

		var percentFilled = ((counter.curr + inc) / counter.end) * 100;
		if (percentFilled > 90) {
			timeoutms = timeoutms + 8 * TIMEOUT_MS;
		} else if (percentFilled > 75) {
			timeoutms = timeoutms + 4 * TIMEOUT_MS;
		} else if (percentFilled > 50) {
			timeoutms = timeoutms + 2 * TIMEOUT_MS;
		}

		// Increment
		item.find(".field-count").html(counter.curr + inc);

		// Update counter
		COUNTERS[i][j] = {
			curr: counter.curr + inc,
			end: counter.end,
		};
		// Reset timeoutms
		COUNTER_TIMEOUTS[i][j] = setTimeout(function () {
			incrementCounter(i, j, item);
		}, timeoutms);
	}

	function onScroll(context) {
		// Get window height and window scroll top
		var windowHeight = $(window).height();
		var windowScrollTop = $(window).scrollTop();

		var dashboardCounters = $(".dashboard_counter__counters", context);
		dashboardCounters.each(function (i) {
			var dashboardCounter = $(this);

			// Get counter items for each counter
			var dashboardCounterItems = dashboardCounter.children(
				".dashboard-counter-item"
			);

			// Iterate through counter items
			dashboardCounterItems.each(function (j) {
				var dashboardCounterItem = $(this);

				var itemOffsetTop = dashboardCounterItem.offset().top;
				var itemHeight = dashboardCounterItem.outerHeight();

				// If item has been scrolled to but has NOT started counting
				if (
					windowScrollTop >
						itemOffsetTop + itemHeight / 2 - windowHeight &&
					itemOffsetTop > windowScrollTop &&
					windowScrollTop + windowHeight >
						itemOffsetTop + itemHeight / 2 &&
					COUNTER_TIMEOUTS[i][j] === undefined
				) {
					// Initialize first timeout for each counter item
					COUNTER_TIMEOUTS[i][j] = setTimeout(function () {
						incrementCounter(i, j, dashboardCounterItem);
					}, TIMEOUT_MS);
				}
			});
		});
	}

	function initScrollListener(context) {
		$(window).on("scroll", function () {
			onScroll(context);
		});
	}

	function initAnimateCounters(context) {
		// If counters have already been initialized, exit
		if (COUNTERS !== undefined) {
			return;
		}
		// Get all counters
		var dashboardCounters = $(".dashboard_counter__counters", context);
		// Establish arrays for all counters
		COUNTERS = new Array(dashboardCounters.length);
		COUNTER_TIMEOUTS = new Array(dashboardCounters.length);

		// Iterate through counters
		dashboardCounters.each(function (i) {
			var dashboardCounter = $(this);

			// Get counter items for each counter
			var dashboardCounterItems = dashboardCounter.children(
				".dashboard-counter-item"
			);
			// Establish arrays for each counter's items
			COUNTERS[i] = new Array(dashboardCounterItems.length);
			COUNTER_TIMEOUTS[i] = new Array(dashboardCounterItems.length);

			// Iterate through counter items
			dashboardCounterItems.each(function (j) {
				var dashboardCounterItem = $(this);

				// Establish intial values for each counter item
				var count = parseInt(
					dashboardCounterItem.attr("data-count"),
					10
				);
				COUNTERS[i][j] = {
					curr: 0,
					end: count,
				};
			});
		});

		$(window).on("load", function () {
			// Check initial position
			onScroll(context);
		});
	}

	Drupal.behaviors.initScrollListener = { attach: initScrollListener };
	Drupal.behaviors.initAnimateCounters = { attach: initAnimateCounters };
})(Drupal, jQuery);
